import { Notifications } from './notifications/Notifications';
import { LogsList } from './logs';
import {
  useMainNav,
  buildDefaultHomeNavItem,
} from '@/app/core/components/main-nav';
import { useDefaultLayoutState, useSetPageTitle } from '@/app/store';
import { OktaUserInfo } from '@/app/core/auth';
import { AccessDenied } from '@/app/core/components/AccessDenied';
import { useEffect, useMemo } from 'react';
import { TabProps, Tabs } from '@ssar-app/uikit';
import { Flex, Text, HStack, Divider, Icon } from '@chakra-ui/react';
import { isAnyProductAdmin, isSuperAdmin } from '@ssar-app/domain';
import { usePathContext } from '@ssar-app/okta-authn-react';
import { AiOutlineBell, AiOutlineFileText } from 'react-icons/ai/index.js';

export const AdminPage = () => {
  useSetPageTitle('Admin');
  const userProfile = OktaUserInfo.getOktaUserInfo();
  const isProductAdmin = isAnyProductAdmin(userProfile);

  const { setNavItems } = useMainNav();
  const { buildPath } = usePathContext();

  const { isSiderCollapsed } = useDefaultLayoutState();

  const navItems = useMemo(() => {
    const navItem = buildDefaultHomeNavItem(isSiderCollapsed, buildPath('/'));
    return [navItem];
  }, [buildPath, isSiderCollapsed]);

  useEffect(() => {
    setNavItems(navItems);
    return () => {
      setNavItems([]);
    };
  }, [buildPath, isSiderCollapsed, navItems, setNavItems]);

  const tabItems = [
    {
      label: (
        <Text>
          <Icon as={AiOutlineBell} mb='-1px' /> Notifications{' '}
        </Text>
      ),
      key: 'Notifications',
      content: <Notifications />,
      isDisabled: false,
    },
    isSuperAdmin(userProfile)
      ? {
          label: (
            <Text>
              <Icon as={AiOutlineFileText} mb='-1px' /> Logs{' '}
            </Text>
          ),
          key: 'logs',
          content: <LogsList />,
          isDisabled: false,
        }
      : null,
  ].filter((tab) => !!tab) as TabProps[];

  if (!isProductAdmin) {
    return <AccessDenied />;
  }

  return (
    <>
      <HStack justify='space-between'>
        <Text fontSize='2xl' fontWeight='semibold' mb={2} color={'black'}>
          Admin Module
        </Text>
      </HStack>
      <Divider mb={4} color='gray.400' />
      <Flex
        direction={'column'}
        bg='#fff'
        // p={'15px'}
        boxShadow='0 3px 10px rgb(0 0 0 / 10%)'
      >
        <Tabs
          colorScheme='blue'
          variant='soft-rounded'
          tabProps={{
            h: 10,
            justifyContent: 'left',
            _selected: {
              border: '0.6px solid blue.800',
              bg: 'gray.100',
              color: 'blue.700',
            },
            _hover: { color: 'blue.700' },
          }}
          items={tabItems}
          tabListProps={{ borderColor: 'gray.500' }}
          tabLabelProps={{ fontSize: 'md' }}
          tabPosition='left'
          padding={4}
          addDivider={true}
        />
      </Flex>
    </>
  );
};
